module.exports = __webpack_public_path__ + "img/TCombined.d8663435.png";